import angular from 'angular';

import StringUtil from './string.util';
import ArrayUtil from './array.util';

export * from './string.util';
export * from './array.util';

export default angular
    .module('common.util', [])
    .factory('stringUtil', StringUtil)
    .factory('arrayUtil', ArrayUtil);



// WEBPACK FOOTER //
// ./src/common/util/index.js